module.exports = __webpack_public_path__ + "img/manifestation-journal_B09PP8VZS8.bbb6f4d6.jpg";